import React, { useState } from "react";
import { MaleModel3D } from "../Common/MaleModel/MaleModel3D";
import ArmRedImg from "../../assets/images/Arm3dRed.png";
import ArmYellowImg from "../../assets/images/Arm3dYellow.png";
import ArmLowImg from "../../assets/images/Arm3dGreen.png";
// for shoulder
import ShoulderRedImg from "../../assets/images/ShoulderRedImg.png";
import ShoulderGreenImg from "../../assets/images/ShoulderGreenImg.png";
import ShoulderYellowImg from "../../assets/images/ShoulderYellowImg.png";

// for UpperBack
import UpperBackDefault from '../../assets/images/UpperBackDefault.png'
import UpperBackNormal from '../../assets/images/UpperBackNormal.png'
import UpperBackMedium from '../../assets/images/UpperBackMedium.png'
import UpperBackHigh from '../../assets/images/UpperBackHigh.png'

// for Mid back
import MidBackDefault from '../../assets/images/MidBackDefault.png';
import MidBackNormal from '../../assets/images/MidBackNormal.png'
import MidBackMedium from '../../assets/images/MidBackMedium.png'
import MidBackHigh from '../../assets/images/MidBackHigh.png';

// for Lower back
import LowerBackDefault from '../../assets/images/LowerBackDefault.png';
import LowerBackNormal from '../../assets/images/LowerBackNormal.png'
import LowerBackMedium from '../../assets/images/LowerBackMedium.png'
import LowerBackHigh from '../../assets/images/LowerBackHigh.png'


// for legs
import LegDetaultImg from '../../assets/images/LegDetaultImg.png';
import LegNormal from '../../assets/images/LegNormalImg.png'
import LegMedium from '../../assets/images/LegMediumImg.png'
import LegHigh from '../../assets/images/LegHighImg.png'

// for Thigh
import ThighDetaultImg from '../../assets/images/ThighDefaultImg.png';
import ThighNormal from '../../assets/images/ThighNormalImg.png'
import ThighMedium from '../../assets/images/ThighMediumImg.png'
import ThighHigh from '../../assets/images/ThighHighImg.png'

// for Neck
import NeckDefaultImg from '../../assets/images/NeckDefaultImg.png';
import NeckNormal from '../../assets/images/NeckNormalImg.png'
import NeckMedium from '../../assets/images/NeckMediumImg.png'
import NeckHigh from '../../assets/images/NeckHighImg.png'

// default image...
import ArmSSimg from "../../assets/images/ArmDefaultImg.png";
import UpperBackSSimg from "../../assets/images/UpperBackSSImg.png";
import LowerBackSSimg from "../../assets/images/LowerBackSSImg.png";
import MidBackSSimg from "../../assets/images/MidBackSSImg.png";
import NeckSSimg from "../../assets/images/ScreenShortNeck.png";
import ShoulderSSimg from "../../assets/images/ShoulderDefaultImg.png";
import LegsSSimg from "../../assets/images/LegDetaultImg.png";
import ThighSSimg from "../../assets/images/ThighSSImg.png";

export const ChoosePainLevel = ({
  screenShotImg,
  selectedPainLocation,
  selectedLoactionMulti,
  setSelectedLocationMulti,
  patientMedicationInfo,
  setPatientMedicationInfo,
}) => {
  const [painIntensity, setPainIntensity] = useState([]);

  const handlePainIntensity = (selectedIntensity, location) => {
    if (location === "Arms") {
      if (selectedIntensity === "Low") {
        // return "bg-green-400";
        return ArmLowImg;
      }
      if (selectedIntensity === "Normal") {
        return ArmYellowImg;
        // return "bg-yellow-400";
      }
      if (selectedIntensity === "High") {
        // return "bg-red-400";
        return ArmRedImg;
      }
      return ArmSSimg;
    }
    if (location === "Shoulder") {
      if (selectedIntensity === "Low") {
        // return "bg-green-400";
        return ShoulderGreenImg;
      }
      if (selectedIntensity === "Normal") {
        return ShoulderYellowImg;
        // return "bg-yellow-400";
      }
      if (selectedIntensity === "High") {
        // return "bg-red-400";
        return ShoulderRedImg;
      }
      return ShoulderSSimg;
    }
    if (location === "Upper Back") {
      if (selectedIntensity === "Low") {
        // return "bg-green-400";
        return UpperBackNormal;
      }
      if (selectedIntensity === "Normal") {
        return UpperBackMedium;
        // return "bg-yellow-400";
      }
      if (selectedIntensity === "High") {
        // return "bg-red-400";
        return UpperBackHigh;
      }
      return UpperBackDefault;
    }
    if (location === "Mid Back") {
      if (selectedIntensity === "Low") {
        // return "bg-green-400";
        return MidBackNormal;
      }
      if (selectedIntensity === "Normal") {
        return MidBackMedium;
        // return "bg-yellow-400";
      }
      if (selectedIntensity === "High") {
        // return "bg-red-400";
        return MidBackHigh;
      }
      return MidBackDefault;
    }
    if (location === "Lower Back") {
      if (selectedIntensity === "Low") {
        // return "bg-green-400";
        return LowerBackNormal;
      }
      if (selectedIntensity === "Normal") {
        return LowerBackMedium;
        // return "bg-yellow-400";
      }
      if (selectedIntensity === "High") {
        // return "bg-red-400";
        return LowerBackHigh;
      }
      return LowerBackDefault;
    }
    if (location === "Legs") {
      if (selectedIntensity === "Low") {
        // return "bg-green-400";
        return LegNormal;
      }
      if (selectedIntensity === "Normal") {
        return LegMedium;
        // return "bg-yellow-400";
      }
      if (selectedIntensity === "High") {
        // return "bg-red-400";
        return LegHigh;
      }
      return LegDetaultImg;
    }
    if (location === "Thigh") {
      if (selectedIntensity === "Low") {
        // return "bg-green-400";
        return ThighNormal;
      }
      if (selectedIntensity === "Normal") {
        return ThighMedium;
        // return "bg-yellow-400";
      }
      if (selectedIntensity === "High") {
        // return "bg-red-400";
        return ThighHigh;
      }
      return ThighDetaultImg;
    }
    if (location === "Neck") {
      if (selectedIntensity === "Low") {
        // return "bg-green-400";
        return NeckNormal;
      }
      if (selectedIntensity === "Normal") {
        return NeckMedium;
        // return "bg-yellow-400";
      }
      if (selectedIntensity === "High") {
        // return "bg-red-400";
        return NeckHigh;
      }
      return NeckDefaultImg;
    }
  };

  const handleDefaultImg = (curPainLoaction) => {
    if (curPainLoaction === "Arms") {
      return ArmSSimg;
    }
    if (curPainLoaction === "Mid Back") {
      return MidBackDefault;
    }
    if (curPainLoaction === "Upper Back") {
      return UpperBackDefault;
    }
    if (curPainLoaction === "Lower Back") {
      return LowerBackDefault;
    }
    if (curPainLoaction === "Neck") {
      return NeckDefaultImg;
    }
    if (curPainLoaction === "Shoulder") {
      return ShoulderSSimg;
    }
    if (curPainLoaction === "Thigh") {
      return ThighDetaultImg;
    }
    if (curPainLoaction === "Legs") {
      return LegDetaultImg;
    }
  };

  return (
    <>
      <div className="flex flex-col  gap-4 mb-8">
        <div className=" flex justify-start items-start p-4  relative">
          <div className="absolute top-0 -left-[20vw] w-full h-full gradientBg" />
          <div className="2xl:p-5 xl:p-5 lg:p-5 md:p-5 p-1 flex flex-col gap-5  rounded-lg 2xl:w-[80%] xl:w-[80%] lg:w-[80%] md:w-[80%] w-[100%]  relative z-20 ">
            <h3 className="font-[600] text-[#333333] 2xl:text-[2.5dvw] xl:text-[2.5dvw] lg:text-[2.5dvw] md:text-[2.5dvw] text-[5dvw] font-[Poppins]">
              Selected Pain Intensity
            </h3>
          </div>
        </div>

        <div className="grid 2xl:grid-cols-2 xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 grid-cols-1 gap-5 bg-transparent rounded-md 2xl:p-5 xl:p-5 lg:p-5 md:p-5 p-2 ">
          {selectedLoactionMulti.map((cur, id) => (
            <div key={id} className="flex justify-between">
              <div className="flex-1">
                <h3 className="font-[600] text-[#333333] 2xl:text-[1.8dvw] xl:text-[1.8dvw] lg:text-[1.8dvw] md:text-[1.8dvw] text-[4.5dvw] font-[Poppins]">
                  {cur.title}
                </h3>

                <div className="grid grid-cols-1 gap-3 2xl:w-[80%] xl:w-[80%] lg:w-[80%] md:w-[80%] w-[100%] mt-5">
                  <button
                    onClick={() => {
                      setPainIntensity([
                        ...painIntensity,
                        {
                          title: "Low",
                          id: id,
                        },
                      ]);
                      setSelectedLocationMulti((prvData) => {
                        const result = prvData.map((curr) =>
                          curr.title === cur.title
                            ? {
                                ...curr,
                                painLevel: cur.painLevel === "Low" ? "" : "Low",
                              }
                            : curr
                        );
                        setPatientMedicationInfo({
                          ...patientMedicationInfo,
                          selectedPainArea: result,
                        });
                        return result;
                      });
                    }}
                    className={` py-2.5 2xl:text-[1.1vw] xl:text-[1.1vw] lg:text-[1.1vw] md:text-[1.1vw] text-[3.5vw] bg-baseColor border-none outline-none rounded-full w-full font-mainFont font-[600] text-[#000]    btnGraident2 transition-all duration-100 ease-in  ${
                      cur.painLevel === "Low" && "text-white bg-green-400 w-full"
                    }`}
                  >
                    Low
                  </button>
                  <button
                    onClick={() => {
                      setPainIntensity([
                        ...painIntensity,
                        {
                          title: "Normal",
                          id: id,
                        },
                      ]);
                      setSelectedLocationMulti((prvData) => {
                        const result = prvData.map((curr) =>
                          curr.title === cur.title
                            ? {
                                ...curr,
                                painLevel:
                                  cur.painLevel === "Normal" ? "" : "Normal",
                              }
                            : curr
                        );
                        setPatientMedicationInfo({
                          ...patientMedicationInfo,
                          selectedPainArea: result,
                        });
                        return result;
                      });
                    }}
                    className={` py-2.5 2xl:text-[1.1vw] xl:text-[1.1vw] lg:text-[1.1vw] md:text-[1.1vw] text-[3.5vw] bg-baseColor border-none outline-none rounded-full w-full font-mainFont font-[600] text-[#000]    btnGraident2 transition-all duration-100 ease-in ${
                      cur.painLevel === "Normal" && "text-white bg-yellow-400"
                    } `}
                  >
                    Medium
                  </button>
                  <button
                    onClick={() => {
                      setPainIntensity([
                        ...painIntensity,
                        {
                          title: "High",
                          id: id,
                        },
                      ]);
                      setSelectedLocationMulti((prvData) => {
                        const result = prvData.map((curr) =>
                          curr.title === cur.title
                            ? {
                                ...curr,
                                painLevel:
                                  cur.painLevel === "High" ? "" : "High",
                              }
                            : curr
                        );

                        setPatientMedicationInfo({
                          ...patientMedicationInfo,
                          selectedPainArea: result,
                        });
                        return result;
                      });
                    }}
                    className={` py-2.5 2xl:text-[1.1vw] xl:text-[1.1vw] lg:text-[1.1vw] md:text-[1.1vw] text-[3.5vw] bg-baseColor border-none outline-none rounded-full w-full font-mainFont font-[600] text-[#000]    btnGraident2 transition-all duration-100 ease-in ${
                      cur.painLevel === "High" && "text-white bg-red-500"
                    } `}
                  >
                    High
                  </button>
                </div>
              </div>

              <div
                id="mobelWrapper"
                className="flex-1 flex justify-center items-center relative"
              >
                <div className="w-[25dvh] h-[25dvh]">
                  <img
                    className="w-full h-full object-cover"
                    src={
                      cur.painLevel
                        ? handlePainIntensity(cur?.painLevel, cur.title)
                        : handleDefaultImg(cur.title)
                    }
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};
